import React, { Component } from 'react';
import {
  formatCurrency,
  formatCryptoCurrency,
  investmentStatuses,
  paymentTypes,
  paymentMethods,
  withAlertHandler,
} from 'entoro-shared';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {
  apolloClient,
  getDocusignEnvelopeMutation,
  getBrokerageDocusignEnvelopeMutation,
} from '../../apollo';
import { DASHBOARD_OFFER_LIMIT as limit } from '../../config';

const getColumnWidth = (data, accessor) => {
  if (typeof accessor === 'string' || accessor instanceof String) {
    accessor = (d) => d[accessor]; // eslint-disable-line no-param-reassign
  }
  const maxWidth = 600;
  const magicSpacing = 12;
  const cellLength = Math.max(
    ...data.map((row) => (`${accessor(row)}` || '').length)
  );
  return Math.min(maxWidth, cellLength * magicSpacing);
};
const getColumnOffer = (data) => {
  const result = data.map((row) => row.typeOfOffer[1]);
  return result;
};
class InvestmentTable extends Component {
  state = {
    loadingEnvelopes: [],
    loadingBrokerageEnvelopes: [],
  };

  openDocusignEnvelope = async (e, offerId, investmentId) => {
    e.preventDefault();
    const { handleSnackbarError } = this.props;

    try {
      const { loadingEnvelopes } = this.state;
      loadingEnvelopes.push(offerId);
      this.setState({ loadingEnvelopes });
      const {
        data: {
          getDocusignEnvelope: { url },
        },
      } = await apolloClient.mutate({
        mutation: getDocusignEnvelopeMutation,
        variables: {
          input: {
            offerId,
            investmentId,
            returnUrl: window.location.href,
          },
        },
      });
      window.location.replace(url);
    } catch (error) {
      this.setState({
        loadingEnvelopes: this.state.loadingEnvelopes.filter(
          (item) => item !== offerId
        ),
      });
      handleSnackbarError(error);
    }
  };

  openBrokerageDocusignEnvelope = async (e, offerId, investmentId) => {
    e.preventDefault();
    const { handleSnackbarError } = this.props;

    try {
      const { loadingBrokerageEnvelopes } = this.state;
      loadingBrokerageEnvelopes.push(offerId);
      this.setState({ loadingBrokerageEnvelopes });
      const {
        data: {
          getBrokerageDocusignEnvelope: { url },
        },
      } = await apolloClient.mutate({
        mutation: getBrokerageDocusignEnvelopeMutation,
        variables: {
          input: {
            offerId,
            investmentId,
            returnUrl: window.location.href,
          },
        },
      });
      window.location.replace(url);
    } catch (error) {
      this.setState({
        loadingBrokerageEnvelopes: this.state.loadingBrokerageEnvelopes.filter(
          (item) => item !== offerId
        ),
      });
      handleSnackbarError(error);
    }
  };

  render() {
    const { loadingEnvelopes, loadingBrokerageEnvelopes } = this.state;
    const { investments } = this.props;
    const columns = [
      {
        Header: 'Offer Name',
        accessor: 'offerName',
        Cell: ({ value, original: { offerId } }) => (
          <Link className='no-link' to={`/offer/${offerId}`}>
            {value}
          </Link>
        ),
      },
      {
        Header: 'Transaction Date',
        accessor: 'transactionDate',
        width: getColumnWidth(investments, 'transactionDate'),
      },
      {
        Header: 'Investment Amount',
        accessor: 'investmentAmount',
        Cell: ({ value, original: { paymentType, investmentAmountCrypto } }) =>
          paymentType.includes('CRYPTO')
            ? formatCryptoCurrency(investmentAmountCrypto)
            : formatCurrency(value),
        width: getColumnWidth(investments, 'investmentAmount'),
      },
      {
        Header: 'Investment Status',
        accessor: 'investmentStatus',
        Cell: (props) => investmentStatuses.getLabel(props.value),
        width: getColumnWidth(investments, 'investmentStatus'),
      },
      {
        Header: 'Payment Method',
        accessor: 'paymentMethod',
        Cell: (props) => paymentMethods.getLabel(props.value),
        width: getColumnWidth(investments, 'paymentMethod'),
      },
      {
        Header: 'Payment Type',
        accessor: 'paymentType',
        Cell: (props) => paymentTypes.getLabel(props.value),
        width: getColumnWidth(investments, 'paymentType'),
      },
      {
        Header: 'Shares or Tokens Purchased',
        accessor: 'sharesOrTokensPurchased',
        Cell: (props) => {
          let type = '';
          if (props.value) {
            type = `${props.original.paymentMethod === 'CRYPTO' ? 'Tokens' : 'Shares'
              }`;
          }
          return `${props.value || 'N/A'} ${type}`;
        },
        width: getColumnWidth(investments, 'sharesOrTokensPurchased'),
      },
      {
        Header: 'Subscription Documents',
        accessor: 'documents',
        Cell: ({ original: { offerId, investmentId } }) => (
          <button
            className='investment-button'
            disabled={loadingEnvelopes.includes(offerId)}
            onClick={(e) => this.openDocusignEnvelope(e, offerId, investmentId)}
          >
            Subscription
          </button>
        ),
      },
      {
        Header: 'Brokerage Documents',
        accessor: 'documents',
        Cell: ({ original: { offerId, investmentId, typeOfOffer } }) => {
          return (
            <button
              className={`investment-button ${typeOfOffer !== 'REG_A' ? 'underline' : ''
                }`}
              disabled={
                loadingBrokerageEnvelopes.includes(offerId) ||
                typeOfOffer !== 'REG_A'
              }
              onClick={(e) =>
                this.openBrokerageDocusignEnvelope(e, offerId, investmentId)
              }
            >
              Brokerage
            </button>
          );
        },

        offer: getColumnOffer(investments),
      },
      {
        Header: 'Continue Investment',
        accessor: 'documents',
        Cell: ({ original: { offerId, investmentId, typeOfOffer } }) => {
          return (
            <button
              style={{ textDecoration: 'none' }}
              className={'investment-button'}
              onClick={() =>
                window.open(
                  `/offer/${offerId}?investmentId=${investmentId}`,
                  '_blank'
                )
              }
            //target='_blank'
            //to={`/offer/${offerId}?investmentId=${investmentId}`}
            >
              Continue
            </button>
          );
        },

        offer: getColumnOffer(investments),
      },
    ];

    return (
      <ReactTable
        data={investments}
        columns={columns}
        minRows={0}
        manual
        sortable={false}
        showPageSizeOptions={false}
        showPagination={false}
        pageSize={limit}
        noDataText="You don't have any investments"
      />
    );
  }
}

InvestmentTable.propTypes = {
  investments: PropTypes.array.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
};

export default withRouter(withAlertHandler(InvestmentTable));



// WEBPACK FOOTER //
// ./src/components/Dashboard/InvestmentTable.js